module.exports={
    btn:{
        tips_reelect_btn:"Nova imagem",
        cancel_btn:"Cancelar",
        tips_continue_dispose:"Upscale imagens suportadas",
        tips_return:"Nova imagem",
        tips_upgrade:"Atualizar",
        tips_yes:"OK",
        delete:"Excluir",
        download:"Download",
        upload_image:"Enviar Imagem",
        new_image:"Nova imagem",
        save_all:"Salvar tudo",
        cancel:"Cancelando",
        save:"Salvar",
        view_comparison:"Ver comparação",
        hide_comparison:"Ocultar comparação",
        previous:"Anterior",
        next:"Próximo",
        continue_download:"Salvar imagens com marcas d'água",
        present:"Aplicar a esta imagem",
        all_wait:"Aplicar a imagens em espera",
        all:"Aplicar a todas as imagens",
        history:"História",
        login:"Conecte-se",
    },
    tips:{
        please_upgrade:"Seu plano atual não suporta upload ou upscaling de imagens em lotes. Atualize-o para aproveitar mais benefícios.",
        errorlistinfo:"XXX imagens estão selecionadas. As imagens XXX são suportadas, mas as imagens XXX não são suportadas. As seguintes imagens não são suportadas:",
        max:"Exceda o limite máximo de tamanho de imagem de 10 MB!",
        max_size:"Exceda o limite máximo de comprimento lateral da imagem de 4096px!",
        continue_dispose:"Upscale imagens suportadas",
        please_multiple:"Selecione a ampliação.",
        max_multiple:"* Sua imagem será ampliada para no máximo 4K (o lado maior não ultrapassará 4096px).",
        title:"Nome",
        reasons:"Motivos",
        upload_type:"Não suportado",
        used_up:"O número de salvamento de imagens HD sem marcas d'água foi esgotado. Atualize sua conta. Ou você pode salvar imagens HD com marcas d'água.",
        edit_multiple:"Existem várias imagens carregadas. Por favor, selecione as imagens que você deseja alterar a ampliação. Após a seleção, essas imagens serão redimensionadas novamente para a nova ampliação.",
        download_confirm:"Algumas imagens ainda estão sendo processadas. Tem certeza de que deseja salvar todas as imagens aprimoradas? Quando você salva a mesma imagem repetidamente, seu número de imagens salvas não será deduzido novamente.",
        waiting_save:"Algumas imagens ainda estão sendo processadas. Salve mais tarde.",
        
    },
    header:{
        title:"AnyMP4 Image Upscaler Online",
        hd:" Imagens HD",
        watermarks:"sem marcas d'água podem ser baixados no momento.",
        view_details:"Ver detalhes",
        loading:"Carregando…",
    },
    content:{
        failed:"Fracassado",
        completed:"Concluído",
        processing:"Em processamento",
        img_processing:"Em processamento…",
        img_failed:"Falha ao processar",
        uploading:"Enviando",
        img_uploading:"Enviando…",
        wait_upoading:"Aguardando para carregar...",
        waiting:"Esperando",
        img_waiting:"Esperando…",
        empty:"Vazio",
        magnification:"Ampliação:",
        drop:"Ou solte seu arquivo de imagem aqui para aumentar e aprimorar!",
        original:"Original:",
        output:"Saída:",
    },
    banner_msg:"Escolha um Plano para Upscaler de Imagem",
    monthly:"POR MÊS",
    lifetime:"VIDA",
    choose_plan:"Escolha seu plano com base no número de imagens",
    return_home:"Parabéns! Você atualizou com sucesso. Volte à página inicial e use este produto.",
    congratulations:"Parabéns! Você atualizou com sucesso. Os benefícios foram vinculados ao endereço de e-mail que você deixou durante a atualização. Por favor, use a conta cadastrada ou vinculada ao endereço de e-mail para",
    login_benefits:"faça o login para usar os benefícios",
    no_registered:". Se você não registrou ou vinculou uma conta com o endereço de e-mail, por favor",
    register_account:"use o endereço de e-mail para registrar uma conta",
    other_accounts:" ou vincule outras contas a este endereço de e-mail para usar os benefícios.",
    btn_close:"Fechar",
    free:"Livre",
    btn_get_started:"Iniciar",
    // access_to:"Acesso a",
    upscale_images:"Imagens de alto nível",
    up_to:"Até",
    per_image:" por imagem",
    resolution_of:"Até a resolução de",
    default_level:"Imagens de upscale no nível padrão",
    image_downloads:"2 downloads de imagens HD sem marca d'água",
    unlimited_image:"Downloads ilimitados de imagens com marca d'água",
    SHA256_encryption:"técnica de criptografia SHA256",
    mon:"Por mês",
    images:"imagens",
    high_resolution:" com qualidade de alta resolução",
    tax_incl:"Imposto incl.",
    image:"imagem",
    secure_checkout:"Check-out seguro",
    everything:"Tudo de Graça, e",
    upscaling_levels:"Todos os níveis de upscaling podem ser selecionados",
    unlimited_image_without:"Downloads ilimitados de imagens sem marca d'água",
    viewable_editing:"O histórico de edição visível é válido para",
    days:" dias",
    high_level:"Alto nível",
    priority_processing:" processamento prioritário",
    left:"Vida",
    resolution:" resolução",


    "history_will":"Vai expirar depois",
    "history.days":"Dias)",
    "history.hours":"horas",
    "expired":"Expirado",
    "access_to":"Com o teste gratuito, você só pode",
    "pricing.upload_images":"Enviar imagens",
    "pricing.under":"sob",
    "pricing.images":"imagens",
    "pricing.without_watermark":"sem marca d'água",
    "pricing.process_images":"Processe imagens até",
    "pricing.pixels":"píxeis",
    "pricing.enjoy_limited":"Desfrute de notas de luxo limitadas",
    "pricing.download":"Download",
    "pricing.HD_images":"Imagens HD sem marca d'água",
    "pricing.and_you":"E você pode sofrer",
    "pricing.slow_upscaling":"upscaling lento",
    "pricing.lower_priority":"menor prioridade",
    "pricing.without":"sem marca d'água",
    "pricing.tax":"O imposto está incluído no preço de venda e será calculado automaticamente com base no seu país e região. No carrinho de compras, você pode ver o valor do imposto detalhado. O valor do seu pagamento final será o mesmo que o preço exibido.",
    "pricing.you_can":"Com assinatura você pode",
    "pricing.up_to":"Carregar imagens até",
    "pricing.upscale_images":"Imagens de alto nível com",
    "pricing.no_watermark":"sem marca d'água",
    "pricing.enhance":"Melhorar",
    "pricing.or_more":"imagens ou mais",
    "pricing.in_batch":"em lote",
    "pricing.enlarge_images":"ampliar imagens em",
    "pricing.and":"e",
    "pricing.times_with":"vezes sem limite",
    "pricing.enjoy":"Aproveitar",
    "pricing.of_history":"do tempo de armazenamento do histórico",
    "pricing.experience":"Experiência",
    "pricing.fast_upscaling":"upscaling rápido",
    "pricing.higher_priority":"prioridade mais alta",
    "pricing.early_access":"Acesso antecipado a novos recursos",
    "pricing.cancel_anytime":"Cancele quando quiser",
    "pricing.lifetime_license":"Com a licença vitalícia você pode",
    "pricing.and_there":"E haverá",
    "pricing.no_expiration":"sem data de validade",
    "pricing.unless":"a menos que você esgote todos os upscales",
    
}